export default function () {
  var w = window;
  var ic = w.Intercom;
  if (typeof ic === "function") {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var l = function () {
      var s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://widget.intercom.io/widget/ntvhrj4m';
      var x = d.getElementsByTagName('script')[0];
      if (x && x.parentNode) {
        x.parentNode.insertBefore(s, x);
      } else {
        (d.head || d.body || d.documentElement).appendChild(s);
      }
    };
    if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      console.log('Non Attached');
      // w.addEventListener('load', l);
      // TODO refactor this
      l();
    }
  }
};